import { Injectable } from '@angular/core';

/**
 * Sustituye las imágenes de markdown que fallan al cargar por su placeholder
 * (`data-fallback-src`, escrito por el renderer de marked) en lugar de dejar el
 * icono roto del navegador. El HTML del markdown pasa por sanitizado, así que no
 * puede llevar handlers inline: se escucha el error a nivel de documento en fase
 * de captura (los eventos de error de <img> no burbujean).
 */
@Injectable({ providedIn: 'root' })
export class FallbackImagenMarkdownService {
  private inicializado = false;

  public inicializar(): void {
    if (this.inicializado) {
      return;
    }
    this.inicializado = true;

    document.addEventListener('error', (event) => this.aplicarFallback(event), true);
  }

  private aplicarFallback(event: Event): void {
    const imagen = event.target;
    if (!(imagen instanceof HTMLImageElement)) {
      return;
    }

    const fallback = imagen.dataset['fallbackSrc'];
    if (!fallback || imagen.src.endsWith(fallback)) {
      return;
    }

    imagen.src = fallback;
    imagen.title = 'Imagen no disponible';
    imagen.classList.add('imagen-fallback');
  }
}
